export const transformAnonymityInfo = (
  anonymityInfo,
  blackList,
  webRtcStatus,
  ips,
) => {
  if (anonymityInfo && blackList) {
    const blackListKeys = Object.keys(blackList);

    const trueElementsCount = blackListKeys.filter(
      key => blackList[key],
    ).length;
    const totalCheckedElements = blackListKeys.length;
    return {
      ...anonymityInfo,
      webRtc: webRtcStatus,
      webRtcIps: ips,
      blacklist: trueElementsCount > 0,
      blacklist_check: `Checks: ${totalCheckedElements},\nBlacklisted: ${trueElementsCount}`,
    };
  }

  return anonymityInfo;
};
